// ⛔️Generated file. Manual changes will be lost ⛔️

export class LogMarkerConsts {
    public static readonly ServiceName: string = 'service.name';
    public static readonly ServiceType: string = 'service.type';
    public static readonly SessionId: string = 'session.id';
    public static readonly SessionUserId: string = 'session.user_id';
    public static readonly SessionJwtId: string = 'session.jwt_id';
    public static readonly OperationNane: string = 'operation.name';
    public static readonly OperationServiceType: string = 'operation.service_type';
    public static readonly OperationWorkflowId: string = 'operation.workflow_id';
    public static readonly OperationCorrelationId: string = 'operation.correlation_id';
    public static readonly OperationCompleted: string = 'operation.isCompleted';
    public static readonly OperationStatusCode: string = 'operation.status_code';
    public static readonly OperationUrl: string = 'operation.url';
    public static readonly OperationMessageDirection: string = 'operation.message_direction';
    public static readonly Error: string = 'error';
    public static readonly ErrorId: string = 'error.id';
    public static readonly ErrorStackTrace: string = 'error.stack_trace';
    public static readonly ErrorMessage: string = 'error.message';
    public static readonly UserTimestamp: string = 'user_timestamp';
    public static readonly TaskChainId: string = 'taskChain.id';
    public static readonly InboundRestCall: string = '[| <- RT]';
    public static readonly OutboundRestCall: string = '[| -> RT]';
}
